import apis from './api.json' ;
import {mock as lkl} from './mock';

const api = {
    ...{baseUrl: process.env.REACT_APP_API_BASE},
    ...apis,
}
const mock = lkl
export {api, mock}